import React from "react";
import styled from "styled-components";
import { IListing, IListingIssueDetails } from "../../../commonTypes";
import useBidCard from "../useBidCard";
import InstantBidDetails from "./InstantBidDetails";
import InstantBidTitle from "./InstantBidTitle";

const Root = styled.div``;

type Props = {
  listing: IListing;
  onClick: () => void;
  issueDetails?: IListingIssueDetails;
};
const InstantBidCard = ({ listing, onClick, issueDetails }: Props) => {
  const { title, price, priceUsd, endTime } = useBidCard(listing);

  return (
    <Root>
      <InstantBidTitle title={title} issueDetails={issueDetails} />
      <InstantBidDetails
        listing={listing}
        price={price}
        priceUsd={priceUsd}
        onClick={onClick}
        endTime={endTime}
      />
    </Root>
  );
};

export default InstantBidCard;
